import {Logger} from '../utils/Logger';
import {Injectable} from '@angular/core';
import {Keys, StorageService} from '../service/storage.service';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class LoanDebtInfoGuard implements CanActivate {
    private readonly router: Router;
    private readonly storageService: StorageService;

    constructor(storageService: StorageService, router: Router) {
        this.storageService = storageService;
        this.router = router;
    }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        if (this.storageService.getItem(Keys.BORROWED_INFO) === 'true') {
            return true;
        } else {
            Logger.log(`Debt info is not available in the loan. Redirecting to the debt info page.`);
            this.router.navigate(['/borrowedinfo']);
            return false;
        }
    }
}